import type {
  FilterConfig,
  FilterDefinition,
  FilterHandler,
} from '../engine/types';
import {
  FilterId,
  FilterType,
  type MultiFilter,
  type RangeFilter,
} from '../types/filters';
import {
  graduationYearDefinition,
  graduationYearHandler,
} from './graduationYear';

export const multiGraduationYearDefinition: FilterDefinition<
  MultiFilter<RangeFilter>
> = {
  id: FilterId.MULTI_GRADUATION_YEAR,
  name: 'Graduation Year',
  type: FilterType.MULTI,
  wrappedFilterId: FilterId.GRADUATION_YEAR,
  instances: [],
  isVisible: true,
};

export const multiGraduationYearHandler: FilterHandler<
  MultiFilter<RangeFilter>
> = {
  isActive(currentFilterState: MultiFilter<RangeFilter>) {
    return currentFilterState.instances.some((instance) =>
      graduationYearHandler.isActive(instance)
    );
  },

  isDefault(
    currentFilterState: MultiFilter<RangeFilter>,
    _definition: FilterDefinition<MultiFilter<RangeFilter>>
  ) {
    return currentFilterState.instances.length === 0;
  },

  getEffectiveFilter(
    currentFilterState: MultiFilter<RangeFilter>,
    _definition: FilterDefinition<MultiFilter<RangeFilter>>,
    config: FilterConfig
  ) {
    const effectiveInstances = currentFilterState.instances.map((instance) =>
      graduationYearHandler.getEffectiveFilter(
        instance,
        graduationYearDefinition,
        config
      )
    );
    return { ...currentFilterState, instances: effectiveInstances };
  },
};
